<template>
  <div class="container login-page account-flow-page forgot-page">
    <nav-bar :hide-in-app="true" />
    <div class="header">
      <div class="login-type">
        <div class="yt-logo">
          <img class="logo-img" src="https://oss.kaoyanvip.cn/attach/file1746538045035.png" alt="logo">
        </div>
        <div class="type-title">忘记密码</div>
      </div>
      <div class="note">验证手机号后重设密码</div>
      <div class="login-form">
        <phone-input :needCode="true" :pad-icon="isPadLogin" />
        <code-input :disCode.sync="disCode" :action="2" :pad-icon="isPadLogin" />
        <pwd-input :pad-icon="isPadLogin" />
        <Submit ref="submit" :disBtn="$checkBtn(form)" @submit="toReset()" btnStr="完成" />
      </div>
    </div>
    <Footer pageType="forgot" />
  </div>
</template>

<script>
import NavBar from "@/components/navbar";
import PhoneInput from "@/components/phoneInput";
import CodeInput from "@/components/codeInput";
import PwdInput from "@/components/pwdInput";
import Submit from "@/components/submit";
import Footer from "@/components/footer";
import { resetPwd } from "@/api/login";
import { Toast } from "vant";
import { startTrackApp } from "@/tongji";
export default {
  name: "forgot",
  components: {
    NavBar,
    PhoneInput,
    CodeInput,
    PwdInput,
    Submit,
    Footer,
  },
  data() {
    return {
      form: {
        mobile: "",
        password: "",
        code: "",
      },
      disCode: true,
    };
  },
  computed: {
    isPadLogin() {
      return document.documentElement.classList.contains('pad-login');
    },
  },
  methods: {
    toReset() {
      let _this = this;
      let { mobile, code, password: new_password } = _this.form;
      let obj = {
        mobile_info: {
          mobile,
          code,
        },
        new_password,
      };
      resetPwd(obj)
        .then(() => {
          Toast("密码已重置成功!");
          setTimeout(() => {
            _this.$router.push("/pwd");
          }, 1000);
        })
        .catch(() => {
          _this.$refs.submit.loading = false;
        });
    },
  },
  mounted() {
    startTrackApp("忘记密码");
  },
};
</script>
